export default __webpack_public_path__ + "static/media/zone-1-master-plan.ec8e0e28.png";